var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 258,
    viewBox: "0 0 149 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1948 126.871C29.3007 169.105 72.5408 194.956 115.774 184.611C159.008 174.266 185.863 131.643 175.757 89.4087C165.651 47.1748 122.411 21.3237 79.1778 31.6687C35.9443 42.0137 9.08899 84.6374 19.1948 126.871Z",
    fill: "#008894"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5400_14540",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 53,
    width: 162,
    height: 159
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.266 208.929C191.555 198.941 218.983 156.463 209.527 114.051C200.072 71.6398 157.314 45.3551 114.025 55.343C70.7354 65.3309 43.3077 107.809 52.7632 150.221C62.2186 192.632 104.977 218.917 148.266 208.929Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5400_14540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.791 23.2147C155.773 33.071 146.614 36.772 150.596 46.6282C154.577 56.4822 163.737 52.7813 167.72 62.6375C171.702 72.4938 162.541 76.1925 166.524 86.0488C170.505 95.9028 179.665 92.2018 183.647 102.058C187.631 111.917 178.471 115.618 182.453 125.474C186.437 135.335 195.597 131.634 199.581 141.494C203.565 151.353 194.405 155.054 198.387 164.91C202.373 174.775 211.533 171.074 215.519 180.939C219.505 190.805 210.345 194.506 214.33 204.369",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.393 31.455C135.375 41.3112 126.215 45.0122 130.198 54.8684C134.179 64.7225 143.339 61.0215 147.321 70.8778C151.304 80.734 142.143 84.4327 146.125 94.289C150.107 104.143 159.266 100.442 163.249 110.298C167.232 120.157 158.072 123.858 162.055 133.714C166.039 143.575 175.199 139.874 179.183 149.735C183.166 159.593 174.006 163.294 177.989 173.15C181.975 183.015 191.134 179.314 195.12 189.18C199.106 199.045 189.947 202.746 193.932 212.609",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.996 39.701C114.978 49.5573 105.819 53.2583 109.801 63.1145C113.782 72.9686 122.942 69.2676 126.925 79.1238C130.907 88.9801 121.746 92.6788 125.729 102.535C129.71 112.389 138.87 108.688 142.852 118.544C146.836 128.403 137.676 132.104 141.658 141.96C145.642 151.821 154.802 148.12 158.786 157.981C162.77 167.839 153.61 171.54 157.592 181.396C161.578 191.262 170.738 187.561 174.724 197.426C178.71 207.291 169.55 210.992 173.535 220.855",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6074 47.9257C94.5898 57.7819 85.43 61.4829 89.4124 71.3391C93.3938 81.1932 102.554 77.4922 106.536 87.3485C110.518 97.2047 101.358 100.903 105.34 110.76C109.321 120.614 118.481 116.913 122.464 126.769C126.447 136.628 117.287 140.328 121.269 150.185C125.254 160.045 134.413 156.344 138.398 166.205C142.381 176.064 133.221 179.765 137.203 189.621C141.189 199.486 150.349 195.785 154.335 205.65C158.321 215.516 149.161 219.217 153.147 229.08",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2188 56.1698C74.2011 66.0261 65.0413 69.727 69.0237 79.5833C73.0051 89.4373 82.165 85.7363 86.1473 95.5926C90.1297 105.449 80.969 109.148 84.9513 119.004C88.9328 128.858 98.0926 125.157 102.075 135.013C106.058 144.872 96.8985 148.573 100.881 158.429C104.865 168.29 114.025 164.589 118.009 174.449C121.992 184.308 112.832 188.009 116.815 197.865C120.801 207.73 129.961 204.029 133.947 213.895C137.933 223.76 128.773 227.461 132.758 237.324",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8242 64.412C53.8066 74.2682 44.6468 77.9692 48.6292 87.8255C52.6106 97.6795 61.7704 93.9785 65.7528 103.835C69.7352 113.691 60.5744 117.39 64.5568 127.246C68.5383 137.1 77.6981 133.399 81.6805 143.255C85.6637 153.114 76.5039 156.815 80.4863 166.671C84.4705 176.532 93.6303 172.831 97.6144 182.692C101.598 192.55 92.4379 196.251 96.4203 206.107C100.406 215.972 109.566 212.272 113.552 222.137C117.538 232.002 108.378 235.703 112.363 245.566",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4258 72.6522C33.4081 82.5085 24.2483 86.2094 28.2307 96.0657C32.2122 105.92 41.372 102.219 45.3544 112.075C49.3367 121.931 40.176 125.63 44.1584 135.486C48.1398 145.34 57.2996 141.639 61.282 151.496C65.2653 161.354 56.1055 165.055 60.0879 174.911C64.072 184.772 73.2318 181.071 77.216 190.932C81.1993 200.79 72.0395 204.491 76.0218 214.348C80.0078 224.213 89.1676 220.512 93.1536 230.377C97.1396 240.242 87.9798 243.943 91.9649 253.806",
    stroke: "#2B2A7B",
    strokeWidth: 7.81043,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottom-right.17df355093de18eafa2213cc51a16e98.svg";
export { ForwardRef as ReactComponent };